module.exports = __webpack_public_path__ + "static/img/banner1.baebcac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutOur/banner1.jpg
// module id = hR9W
// module chunks = 1